export const SET_DOCJSON = "SET_DOCJSON";
export const SET_DEPENDENCY_JSON = "SET_DEPENDENCY_JSON";
export const SET_DYNAMIC_OPTION_DONE = "SET_DYNAMIC_OPTION_DONE";
export const UPDATE_DYNAMIC_OPTION_DONE = "UPDATE_DYNAMIC_OPTION_DONE";
export const SET_ORG_ID_CONST = "SET_ORG_ID_CONST";
export const SET_CHANGES_LOG = "SET_CHANGES_LOG";
export const SET_STORE_VALS = "SET_STORE_VALS";
export const SET_ATHENA_STORAGE = "SET_ATHENA_STORAGE";
export const UPDATE_ATHENA_STORAGE = "UPDATE_ATHENA_STORAGE";
export const SET_ONE_SIDE_PDF_KEY = "SET_ONE_SIDE_PDF_KEY";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_FOCUSED_SERVICE_ID = "SET_FOCUSED_SERVICE_ID";
export const RERENDER = "RERENDER";
export const SET_DIALOG_DATA = "SET_DIALOG_DATA";
export const SET_VALIDATION_ERROR = "SET_VALIDATION_ERROR";
export const UPDATE_VALIDATION_ERROR = "UPDATE_VALIDATION_ERROR";
export const CLEAR_VALIDATION_ERROR = "CLEAR_VALIDATION_ERROR";
export const ADD_CHILDREN = "ADD_CHILDREN";
export const CHANGE_FORM_VALUES = "CHANGE_FORM_VALUES";
export const INITIAL = "INITIAL";